import styled from "styled-components";

export const Container = styled.div`
    padding: 20px;
    width: 100%;
    box-sizing: border-box;

    @media (max-width: 990px) {
        padding: 20px;
    }

    .historico {
        margin-top: 24px;
        padding: 0;
        width: 100%;
        box-sizing: border-box;

        @media (max-width: 990px) {
            margin-top: 24px;
            padding: 0;
        }
    }
`;
